import { useState } from 'react';
import { Link } from 'react-router-dom';
import { workspaceApi, type Workspace } from '../../api/workspaces';

export function WorkspaceSearchPage() {
  const [query, setQuery] = useState('');
  const [status, setStatus] = useState('');
  const [ownerId, setOwnerId] = useState('');
  const [type, setType] = useState('');
  const [results, setResults] = useState<Workspace[]>([]);
  const [count, setCount] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function search() {
    setLoading(true);
    setError('');
    try {
      const params: Record<string, string> = {};
      if (query.trim()) params.q = query.trim();
      if (status) params.status = status;
      if (ownerId.trim()) params.owner_id = ownerId.trim();
      if (type.trim()) params.type = type.trim();
      const res = await workspaceApi.search(params);
      setResults(res.results ?? []);
      setCount(res.count ?? 0);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Search failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/workspaces" className="text-sm text-slate-600 hover:underline">
        ← Workspaces
      </Link>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Workspace Search</h1>

      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}

      <div className="mt-6 grid gap-3 rounded-xl border border-slate-200 bg-white p-4 md:grid-cols-2">
        <input placeholder="Query" value={query} onChange={(e) => setQuery(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2" />
        <input placeholder="Owner ID" value={ownerId} onChange={(e) => setOwnerId(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2" />
        <input placeholder="Type" value={type} onChange={(e) => setType(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2" />
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="rounded-lg border border-slate-300 px-3 py-2">
          <option value="">Any status</option>
          <option value="pending">Pending</option>
          <option value="active">Active</option>
          <option value="suspended">Suspended</option>
          <option value="archived">Archived</option>
        </select>
        <button type="button" onClick={() => void search()} className="rounded-lg bg-slate-900 px-4 py-2 text-white md:col-span-2 md:w-fit">
          {loading ? 'Searching…' : 'Search'}
        </button>
      </div>

      <p className="mt-4 text-sm text-slate-500">{count} results</p>
      <ul className="mt-4 space-y-3">
        {results.map((ws) => (
          <li key={ws.id} className="rounded-xl border border-slate-200 bg-white p-4">
            <Link to={`/workspaces/${ws.id}`} className="font-medium text-slate-900 hover:underline">
              {ws.name}
            </Link>
            <p className="text-sm text-slate-600">{ws.slug} · {ws.status}</p>
            <Link to={`/workspaces/${ws.id}/dashboard`} className="mt-2 inline-block text-xs text-slate-600 hover:underline">
              Dashboard
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
